import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type DebtorDataReport, type RiskMatrixState } from '../types';

const updateDebtorDataReportCase: CaseReducer<
  RiskMatrixState,
  PayloadAction<DebtorDataReport>
> = (state, action) => {
  state.debtor.report = {
    ...state.debtor.report,
    ...action.payload,
  };

  return state;
};

export { updateDebtorDataReportCase };
